__turbopack_context__.v({
  "GDPRChangeButton": "Vav18G_GDPRChangeButton",
});
